export default __webpack_public_path__ + "static/media/033-exercise.37c141a7.svg";